var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTreatmentSummaryConcern = function SvgTreatmentSummaryConcern(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D6D6D6",
    d: "M16 24.97c6.075 0 11-4.477 11-10s-4.925-10-11-10-11 4.477-11 10 4.925 10 11 10"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#D6D6D6",
    d: "M14.42 24.87a1.14 1.14 0 0 1 .6 1.55c-.67 1.83 6.29-1 9.79-5.4s-10.39 3.85-10.39 3.85"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF6726",
    d: "M17.7 12.67c0-.82-.59-1.3-1.63-1.3a2.22 2.22 0 0 0-2.13 1.59l-2.11-1.22a4.52 4.52 0 0 1 4.33-2.77c2 0 4 1.22 4 3.53 0 2.68-3 3.46-3 5H14.7c0-2.32 3-3.06 3-4.83m-3.29 7.78a1.52 1.52 0 1 1 3.04 0 1.52 1.52 0 0 1-3.04 0"
  })));
};
export default SvgTreatmentSummaryConcern;